"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Radio = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Radio = require("./Radio.styled");

var _ = require("..");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var RadioOutlineBlankIcon = function RadioOutlineBlankIcon(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }));
};

RadioOutlineBlankIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var RadioIcon = function RadioIcon(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("path", {
    d: "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }));
};

RadioIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var Radio =
/*#__PURE__*/
function (_Component) {
  _inherits(Radio, _Component);

  function Radio(props) {
    var _this;

    _classCallCheck(this, Radio);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Radio).call(this, props));

    _initialiseProps.call(_assertThisInitialized(_this));

    var isSelected = _this.props.isSelected;
    _this.state = {
      previouslySelected: isSelected
    };
    return _this;
  }

  _createClass(Radio, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var previouslySelected = this.state.previouslySelected;
      var isSelected = this.props.isSelected; // if props have changed, and the radio button was previously selected
      // then set previously selected to false

      if (prevProps.isSelected !== isSelected && previouslySelected) {
        this.setState({
          previouslySelected: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          name = _this$props.name,
          value = _this$props.value,
          isSelected = _this$props.isSelected,
          children = _this$props.children,
          disabled = _this$props.disabled,
          color = _this$props.color,
          className = _this$props.className,
          backgroundColor = _this$props.backgroundColor,
          styleAs = _this$props.styleAs;
      var previouslySelected = this.state.previouslySelected;
      return _react.default.createElement(_Radio.StyledRadioLabel, {
        htmlFor: id,
        className: className,
        color: color,
        disabled: disabled,
        isSelected: isSelected,
        previouslySelected: previouslySelected,
        backgroundColor: backgroundColor,
        styleAs: styleAs
      }, _react.default.createElement(_Radio.StyledRadioInput, {
        disabled: disabled,
        id: id,
        name: name,
        onChange: this.handleChange,
        value: value,
        checked: isSelected
      }), _react.default.createElement(_Radio.StyledRadioIcon, {
        hide: styleAs !== 'default'
      }, _react.default.createElement(_.Icon, {
        disabled: disabled,
        height: "1.2em",
        width: "1.2em",
        color: color
      }, isSelected ? _react.default.createElement(RadioIcon, null) : _react.default.createElement(RadioOutlineBlankIcon, null))), children);
    }
  }]);

  return Radio;
}(_react.Component);
/**
 * Definition of default values for component props
 */


exports.Radio = Radio;

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleChange = function (e) {
    var _this2$props = _this2.props,
        disabled = _this2$props.disabled,
        isSelected = _this2$props.isSelected,
        onChange = _this2$props.onChange;
    e.preventDefault();

    if (!disabled && !isSelected) {
      onChange(e);

      _this2.setState({
        previouslySelected: true
      });
    }
  };
};

Radio.defaultProps = {
  id: undefined,
  name: undefined,
  onChange: undefined,
  value: undefined,
  isSelected: undefined,
  children: undefined,
  disabled: undefined,
  color: undefined,
  className: undefined,
  backgroundColor: undefined,
  styleAs: 'default'
};
/**
 * Definition of types for component props
 */

Radio.propTypes = {
  /** Children nodes */
  children: _propTypes.default.node,

  /** The icon color property */
  color: _propTypes.default.string,

  /** Whether it is disbled or not */
  disabled: _propTypes.default.bool,

  /** Whether it is checked or not */
  isSelected: _propTypes.default.bool,

  /** Input name */
  name: _propTypes.default.string.isRequired,

  /** Input value */
  value: _propTypes.default.oneOfType([_propTypes.default.string.isRequired, _propTypes.default.number.isRequired]),

  /** Component className */
  className: _propTypes.default.string,

  /** Component id */
  id: _propTypes.default.string,

  /** onChange event handler */
  onChange: _propTypes.default.func,
  backgroundColor: _propTypes.default.string,
  styleAs: _propTypes.default.oneOf(['default', 'pill'])
};